module.exports = __webpack_public_path__ + "static/img/arrow.f041a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = OsgU
// module chunks = 0